import Header from 'components/Header';
import { Box, useTheme, Tabs, Tab } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { colorTheme } from '../../theme';
import PersonalDetails from './PersonalDetails';
import Dashboard from './Dashboard';
import LifetimeGoal from './LifetimeGoal';
import PlanDetails from 'pages/employeesDetails/planDetails';
import Transactions from './Transactions';
import PensionAggregate from 'pages/employeesDetails/pensionAggregate';
import Chats from './Chats';
import Documents from 'pages/employeesDetails/documents';
import ComplaintsRaised from './ComplaintsRaised';
import { strings } from 'i18n/Strings';
import { customerDetailsTabs } from 'constants/constantText';
import Holdings from 'pages/employeesDetails/holdings';
import { getTabIndexFromLocalStorage } from 'utils/GeneralUtil';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps): JSX.Element {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3, height: '75vh' }}>{children}</Box>}
    </div>
  );
}

const CustomerDetails = (): JSX.Element => {
  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);

  /* Tab Menu */
  const [value, setValue] = useState(
    getTabIndexFromLocalStorage('customerDetailsTab'),
  );
  const [fullName, setFullName] = useState('');
  const handleChange = (
    event: React.SyntheticEvent,
    newValue: number,
  ): void => {
    setValue(newValue);
  };

  useEffect(() => {
    return () => {
      sessionStorage.removeItem('customerDetailsTab');
    };
  }, []);

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 2 }}>
        <Header
          title={strings.displayText.customerDetails}
          subtitle={fullName}
        />
      </Box>

      {/* Seporator */}
      <Box py={2} />

      {/* GRID & CHARTS */}

      <Box
        sx={{
          maxWidth: {
            xs: 320,
            sm: 480,
            md: '100%',
          },
          borderRadius: 3,
          px: 2,
          boxShadow: 2,
          bgcolor: 'background.paper',
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          indicatorColor="secondary"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          TabIndicatorProps={{
            style: {
              backgroundColor: colors.greenAccent[600],
            },
          }}
          sx={{
            '& .MuiTab-root.Mui-selected': {
              color: colors.greenAccent[500],
            },
          }}
        >
          <Tab label={strings.displayText.dashboardTab} />
          {customerDetailsTabs.map((ele) => (
            <Tab key={ele} label={strings.displayText[ele]} />
          ))}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Dashboard setFullName={setFullName} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <PersonalDetails />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <LifetimeGoal />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <PlanDetails />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <Transactions />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <Holdings />
      </TabPanel>
      <TabPanel value={value} index={6}>
        <PensionAggregate />
      </TabPanel>
      <TabPanel value={value} index={7}>
        <Chats />
      </TabPanel>
      <TabPanel value={value} index={8}>
        <Documents />
      </TabPanel>
      <TabPanel value={value} index={9}>
        <ComplaintsRaised />
      </TabPanel>
    </Box>
  );
};

export default CustomerDetails;
